/* =========================================================
  CMMP Header Controller (Unified)
  - Desktop/Tablet: Mega menus (click pin + hover open + hover-safe)
  - Mobile: Drawer open/close + accordions
========================================================= */

(function () {
  const header = document.querySelector("[data-cmmp-header]");
  if (!header) return;

  const mqMobile = window.matchMedia("(max-width: 767px)");

  /* -------------------------
    MOBILE DRAWER
  ------------------------- */
  const burger = header.querySelector("[data-cmmp-burger]");
  const drawer = header.querySelector("[data-cmmp-drawer]");
  const backdrop = header.querySelector("[data-cmmp-backdrop]");
  const closeBtn = header.querySelector("[data-cmmp-close]");

  const ensureLockStyle = () => {
    if (document.getElementById("cmmp-lock-style")) return;
    const styleLock = document.createElement("style");
    styleLock.id = "cmmp-lock-style";
    styleLock.textContent = `.cmmp-lock { overflow: hidden !important; }`;
    document.head.appendChild(styleLock);
  };
  ensureLockStyle();

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    if (burger) burger.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("cmmp-lock");
    document.body.classList.add("cmmp-lock");
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    if (burger) burger.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("cmmp-lock");
    document.body.classList.remove("cmmp-lock");
  };

  burger && burger.addEventListener("click", () => {
    // On mobile, burger should toggle
    const isOpen = drawer && drawer.classList.contains("is-open");
    if (isOpen) closeDrawer();
    else openDrawer();
  });

  closeBtn && closeBtn.addEventListener("click", closeDrawer);
  backdrop && backdrop.addEventListener("click", closeDrawer);

  /* -------------------------
    MOBILE ACCORDIONS
  ------------------------- */
  const accTriggers = header.querySelectorAll("[data-acc-trigger]");

  const closeAcc = (name) => {
    const trigger = header.querySelector(`[data-acc-trigger="${name}"]`);
    const panel = header.querySelector(`[data-acc-panel="${name}"]`);
    const item = trigger ? trigger.closest(".cmmp-mnav__item") : null;
    if (!trigger || !panel || !item) return;

    trigger.setAttribute("aria-expanded", "false");
    panel.hidden = true;
    item.classList.remove("is-open");
  };

  const openAcc = (name) => {
    const trigger = header.querySelector(`[data-acc-trigger="${name}"]`);
    const panel = header.querySelector(`[data-acc-panel="${name}"]`);
    const item = trigger ? trigger.closest(".cmmp-mnav__item") : null;
    if (!trigger || !panel || !item) return;

    trigger.setAttribute("aria-expanded", "true");
    panel.hidden = false;
    item.classList.add("is-open");
  };

  accTriggers.forEach((btn) => {
    btn.addEventListener("click", () => {
      const name = btn.getAttribute("data-acc-trigger");
      const expanded = btn.getAttribute("aria-expanded") === "true";

      ["services", "locations"].forEach((n) => {
        if (n !== name) closeAcc(n);
      });

      if (expanded) closeAcc(name);
      else openAcc(name);
    });
  });

  /* -------------------------
    DESKTOP/TABLET MEGA MENUS (HOVER SAFE + CLICK PIN)
    Uses your markup:
      triggers: [data-mega-trigger="services/locations"]
      panels:   [data-mega-panel="services/locations"]
      root:     [data-mega-root]
  ------------------------- */
  const megaTriggers = header.querySelectorAll("[data-mega-trigger]");
  const megaPanels = header.querySelectorAll("[data-mega-panel]");

  function closeAllMegas(exceptName) {
    megaPanels.forEach((p) => {
      if (exceptName && p.getAttribute("data-mega-panel") === exceptName) return;
      p.classList.remove("is-open");
    });
    megaTriggers.forEach((t) => {
      if (exceptName && t.getAttribute("data-mega-trigger") === exceptName) return;
      t.setAttribute("aria-expanded", "false");
      t.removeAttribute("data-mega-pinned");
    });
  }

  function openMega(name, { pinned = false } = {}) {
    const panel = header.querySelector(`[data-mega-panel="${name}"]`);
    const trigger = header.querySelector(`[data-mega-trigger="${name}"]`);
    if (!panel || !trigger) return;

    closeAllMegas(name);

    panel.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");

    if (pinned) trigger.setAttribute("data-mega-pinned", "true");
    else trigger.removeAttribute("data-mega-pinned");
  }

  function isMegaPinned(name) {
    const trigger = header.querySelector(`[data-mega-trigger="${name}"]`);
    return trigger && trigger.getAttribute("data-mega-pinned") === "true";
  }

  megaTriggers.forEach((trigger) => {
    const name = trigger.getAttribute("data-mega-trigger");
    const root = trigger.closest("[data-mega-root]");
    const panel = header.querySelector(`[data-mega-panel="${name}"]`);
    if (!panel) return;

    // Click toggle pinned (desktop/tablet only)
    trigger.addEventListener("click", (e) => {
      if (mqMobile.matches) return;

      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      const pinned = trigger.getAttribute("data-mega-pinned") === "true";

      // If trigger is <a href="">, first click should open, not navigate
      const isLink = trigger.tagName.toLowerCase() === "a" && trigger.getAttribute("href");
      if (isLink) e.preventDefault();

      if (!isOpen) {
        openMega(name, { pinned: true });
        return;
      }

      // open + pinned -> close
      if (pinned) {
        closeAllMegas();
        return;
      }

      // open but not pinned -> pin it
      openMega(name, { pinned: true });
    });

    // Hover open (desktop/tablet only) + hover-safe close
    if (root) {
      let hoverTimer;

      root.addEventListener("mouseenter", () => {
        if (mqMobile.matches) return;
        if (isMegaPinned(name)) return;
        openMega(name, { pinned: false });
      });

      root.addEventListener("mouseleave", () => {
        if (mqMobile.matches) return;
        if (isMegaPinned(name)) return;

        clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(() => {
          // if still hovering root or panel, keep open
          const stillHover =
            root.matches(":hover") ||
            panel.matches(":hover") ||
            trigger.matches(":hover");

          if (!stillHover) closeAllMegas();
        }, 80);
      });
    }
  });

  // Close on outside click (desktop/tablet)
  document.addEventListener("click", (e) => {
    if (mqMobile.matches) return;
    if (!header.contains(e.target)) closeAllMegas();
  });

  // ESC closes drawer + megas
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeDrawer();
    closeAllMegas();
  });

  // Breakpoint change: keep state correct
  const onBreakpointChange = () => {
    if (mqMobile.matches) {
      // Going to mobile: close megas
      closeAllMegas();
    } else {
      // Going to desktop/tablet: close drawer + accordions
      closeDrawer();
      ["services", "locations"].forEach(closeAcc);
    }
  };

  mqMobile.addEventListener
    ? mqMobile.addEventListener("change", onBreakpointChange)
    : mqMobile.addListener(onBreakpointChange);
})();